import React from 'react';

import {
  BooleanField,
  BooleanInput,
  Filter,
  NumberField,
  ShowButton,
  TextField,
} from 'react-admin';

import { IDSearch } from '../../reusable/IDSearch';
import ClipboardField from '../components/ClipboardField';
import InfiniteList from '../components/InfiniteList';
import { WriteOnlyDatagrid } from '../components/WriteOnlyDatagrid';
import { WriteOnlyEditButton } from '../components/WriteOnlyEditButton';

const ClientFilters: React.FC = (props) => (
  <Filter {...props}>
    <IDSearch label="Name" source="name" alwaysOn />
    <BooleanInput label="Archived" source="isArchived" />
  </Filter>
);

export const ClientList: React.FC = () => (
  <InfiniteList filters={<ClientFilters />} perPage={20}>
    <WriteOnlyDatagrid bulkActionButtons={false}>
      <ClipboardField source="id" sortable={false} />
      <TextField source="name" sortable={false} />
      <NumberField source="users.count" label="Users" sortable={false} />
      <TextField
        source="users.lastMboImportDate"
        label="Last MBO Import"
        sortable={false}
      />
      <TextField
        source="users.lastFileImportDate"
        label="Last File Import"
        sortable={false}
      />
      <BooleanField source="isArchived" label="Is archived" sortable={false} />
      <WriteOnlyEditButton />
      <ShowButton />
    </WriteOnlyDatagrid>
  </InfiniteList>
);
